import PropTypes from 'prop-types'

import { createClient } from '../utils/prismic'

import ContactDetail from '../components/contact/ContactDetail'
import FloatingBanner from '../components/FloatingBanner'
import { useGlobal } from '../context/GlobalContext'
import { REVALIDATE_TIME_INTERVAL } from '../data/constants'

const Contact = (props) => {
  const {
    data
  } = props

  const [{
    contact_us_banner_message: bannerMessage,
    contact_us_banner_show: showBannerDefault
  }] = useGlobal()

  return (
    <>
      <FloatingBanner
        bannerMessage={bannerMessage}
        showBannerDefault={showBannerDefault}
        bannerName={'contact-us-banner'}
      />
      <ContactDetail data={data} /> </>
  )
}

export async function getStaticProps({ preview = null, previewData = {} }) {
  const client = createClient({ previewData })
  const { data } = await client.getByUID('contact', 'contact')

  return {
    props: {
      data,
      preview,
    },
    revalidate: preview ? 1 : REVALIDATE_TIME_INTERVAL
  }
}

Contact.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired
}

export default Contact
